import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Orderer'

/**
 */
class Orderer extends BaseProcessor{
  static getClassName(){ return 'Orderer' }

  /**
   */
  static get(input){
    return new Promise(function(resolve, reject) {
      API.get(input)
        .then((res)=>{
          return resolve({status:"ok",data:{orderer:res.orderer} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static save(input){
    return new Promise(function(resolve, reject) {
      API.save(input)
        .then((res)=>{
          return resolve({status:"ok",data:{orderer:res.orderer} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }
}

export default Orderer



// WEBPACK FOOTER //
// ./src/processor/Orderer.js